export class WMS_Sources{
	constructor(){
		
		// SENTINEL
		this.sentinelHubSettings = this.getSentinelHubSettings();
		this.sentinelHubLayers = this.getSentinelHubLayers();
		this.sentinelHubTileDefaultParameters = this.getSentinelHubTileDefaultParameters();
				
		// GURS WMS
		
	}
	
	/*** SENTINEL ***/
	
	// SENTINEL HUB SETTINGS
	getSentinelHubSettings(){
		return {
			"user_key":"9fad3ba1-fed2-4b9b-b6ea-354b6d765c23",
			"protocol":"https",
			"hostnames":[	"services.sentinel-hub.com",
							"services-uswest2.sentinel-hub.com"],
			"services":[	"wms",
							"fis"]			
		};
	}
	
	// SENTINEL HUB LAYERS
	getSentinelHubLayers(){
		return [
				{	"hostname":this.sentinelHubSettings.hostnames[1],
					"tileSettings":{					
						"id":"LST",
						"title": "LST 100x100",									
						"params":{
							"preset":"LST_LANDSAT2",
							"layers":"LST_LANDSAT2,DATE",
							"maxcc":70,
						},
					},
					"wmsPointSettings": {layer: 	'LST_LANDSAT_FLOAT'}
				},
				{	"hostname":this.sentinelHubSettings.hostnames[0],
					"tileSettings":{
						"id":"NDMI",
						"title": "NDMI/NDWI 20x20",									
						"params":{
							"preset":"MOISTURE_INDEX",
							"layers":"MOISTURE_INDEX,DATE",
							"maxcc":70,
						},
					},
					"wmsPointSettings": {	layer: 	'MOISTURE_INDEX2',}
				},
				{	"hostname":this.sentinelHubSettings.hostnames[0],
					"tileSettings":{
						"id":"NDVI",	
						"title": "NDVI 10x10",									
						"params":{
							"preset":"NDVI",
							"layers":"NDVI,DATE",
							"maxcc":70,
						},
					},
					"wmsPointSettings": {	layer: 	'NDVI_FLOAT',}
				},
				{	"hostname":this.sentinelHubSettings.hostnames[0],
					"tileSettings":{					
						"id":"NMDI",
						"title": "NMDI 20x20",									
						"params":{
							"preset":"NMDI",
							"layers":"NMDI,DATE",
							"maxcc":70,
						},
					},
					"wmsPointSettings": {layer: 	'NMDI_FLOAT',}
				},				
				{	"hostname":this.sentinelHubSettings.hostnames[0],
					"tileSettings":{					
						"id":"trueColor",
						"title": "Natural Color (True Color)",									
						"params":{
							"preset":"TRUE_COLOR",
							"layers":"TRUE_COLOR",
							"maxcc":70,
						},
					},
				},
			];
	}
	
	// default WMS parameters, which are used, if they are not set in layers settings above
	getSentinelHubTileDefaultParameters(){
		return {
			"maxcc":70,
			"minZoom":6,
			"maxZoom":16,
		};
	}
	
	// prepare sentinel tile layers
	getSentinelHubTileLayers(){
		let that = this;
		let output = [];
		this.sentinelHubLayers.forEach(function(layer){
			if(typeof(layer.tileSettings) != "undefined"){
				let box = {};				
				let hs = that.sentinelHubSettings;
				
				box.id = layer.tileSettings.id;
				box.url = hs.protocol+"://"+layer.hostname+"/ogc/"+hs.services[0]+"/"+hs.user_key;				
				box.title = layer.tileSettings.title;
				box.params = Object.assign({},that.sentinelHubTileDefaultParameters,layer.tileSettings.params);
				box.visible = true;
				
				output.push(box);
			}
		});
		
		return output;
	}	
	
	
}